import React from "react";
import styles from "./WebPushRegister.module.css";

import LogoPush from "../../assets/web_not.svg";
import PaginationListTable from "../../Components/PaginationListTable/PaginationListTable"

const WebPushRegister = () => {
  React.useEffect(() => {
  }, []);
  const recurrenceTranslation = {
    "monthly": "mensal",
    "weekly": "semanal",
    "daily": "diário"
  }
  return (
    <PaginationListTable
      collection="registros-envios-web-push"
      orderby="dateSend"
      orderbyOrientation="desc"
      logo={LogoPush}
      tableTitle="Registros Web Notifications"
      searchKeyword="Procure por Usuário"
      tableHeaders={{
        "Título": "title",
        "E-mail": "emailSended",
        "Data agendamento": "dateSchedule",
        "Data de criação": "dateSend",
        "Publico": "audience",
        "Status": "status",
        "Recorrência": "recurrence",
        "URL": "url"

      }}
      translation={{"recurrence":recurrenceTranslation}}
    />
  );
};

export default WebPushRegister;
